<template>
  <div>
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240); margin-bottom: 15px"
      :title="this.project"
      :sub-title="this.credit_letter"
      @back="() => this.$router.back()">
    </a-page-header>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" icon="plus" @click="handleAdd">新建</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a>删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      v-if="visible"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
  </div>
</template>

<script>
import { STable } from '@/components'
import { Dictionaries } from '@/common/AllConstant'
import CreateForm from '../modules/CreateForm'
import { credit_letter_repayment_detail_list, credit_letter_repayment_detail_create, credit_letter_repayment_detail_delete } from '@/api/trade_credit_letter_repayment_detail'
import debounce from 'lodash/debounce'
import { project_list } from '@/api/trade_project'
import { client_list } from '@/api/trade_client'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm
  },
  data () {
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    this.clientSearch = debounce(this.handleClientSearch, 800)
    return {
      loading: false,
      confirmLoading: false,
      dictionaries: Dictionaries,
      // 创建窗口控制
      visible: false,
      mdl: {},
      projectList: [],
      clientList: [],
      project: '',
      credit_letter: '',
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '授信银行',
          dataIndex: 'bank',
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '信用证货币金额',
          dataIndex: 'amount',
          ellipsis: true
        },
        {
          title: '人民币金额',
          dataIndex: 'amount_cny',
          ellipsis: true
        },
        {
          title: '信用证货币到人民币的汇率',
          dataIndex: 'to_cny_rate',
          ellipsis: true
        },
        {
          title: '融资利率',
          dataIndex: 'financing_rate',
          ellipsis: true
        },
        {
          title: '总计费用',
          dataIndex: 'total_amount',
          ellipsis: true
        },
        {
          title: '还款日期',
          dataIndex: 'repayment_date',
          ellipsis: true,
          width: 150
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          width: 150
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 100,
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData.parameter', parameter)
        return credit_letter_repayment_detail_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            console.log(res.data, '我是数据列表@')
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.queryParam = {
      credit_letter_repayment_id: this.$route.params.credit_letter_repayment_id
    }
    this.project = this.$route.query.project
    this.credit_letter = '信用证编号：' + this.$route.query.credit_letter
    this.tableOption()
    this.handleProjectSearch(undefined)
    this.handleClientSearch(undefined)
  },
  methods: {
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      this.mdl = { credit_letter_id: this.$route.query.credit_letter_id }
      this.visible = true
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleEdit (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/credit_letter_repayment_detail/' + record.id })
    },
    handleDelete (record) {
      credit_letter_repayment_detail_delete(record.id).then((res) => {
        console.log(res)
        console.log('删除成功------')

        this.$refs.table.refresh()
      })
    },
    handleOk (date) {
      const form = this.$refs.createModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
            // 新增
          values.credit_letter_repayment_id = this.$route.params.credit_letter_repayment_id
          values = { ...values, ...date }
          credit_letter_repayment_detail_create(values).then(res => {
              this.visible = false
              this.confirmLoading = false
              // 重置表单数据
              form.resetFields()
              // 刷新表格
              if (res.code === 1000) {
                this.$refs.table.refresh()
              }
            console.log('删除成功------')
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleProjectSearch (value) {
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      })
    },
    handleProjectChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleProjectSearch(value)
      }
    },
    handleClientSearch (value) {
      client_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.clientList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      })
    },
    handleClientChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleClientSearch(value)
      }
    }
  }
}
</script>
